import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ENewReviewFlow } from '../../types/newReview';

export enum EFlowActionTypes {
  Set = 'NEW_REVIEW/FLOW/SET',
}

export type TSetFlow = ITypedReduxAction<EFlowActionTypes.Set, ENewReviewFlow>;

export type TNewReviewFormFlowActions = TSetFlow;

export const setFlow: (flow: ENewReviewFlow) => TSetFlow = actionGenerator<EFlowActionTypes.Set, ENewReviewFlow>(
  EFlowActionTypes.Set,
);
